//INTRODUCTION
export const introduction = (
    profile = {}
) => ({
    type: 'INTRODUCTION',
    profile
});


// WEBPACK FOOTER //
// ./src/actions/introduction.js